import type { SaveService } from './save';

export async function GetDefaultSavedSearchTitle(this: SaveService): Promise<number> {
  if (!this.stateService.userToken()) {
    return 0;
  }

  const _url = 'https://api.v2.thevillages.com/users/saved-search-count';
  const _authorization = `Bearer ${this.stateService.userToken()}`;
  const _options: RequestInit = {
    headers: {
      Authorization: _authorization,
      // eslint-disable-next-line @typescript-eslint/naming-convention -- This is the correct header name for content type.
      'Content-Type': 'application/json',
    },
  };

  const _result = await fetch(_url, _options);

  if (!_result.ok) {
    return 0;
  }

  const _resultJson = (await _result.json()) as number;

  return _resultJson;
}
